var NotificationBase = require('../NotificationBase');
var features = require('diy/util/features');

/* globals jimdoData, diy */
(function () {

    'use strict';

    var ChatNotification = NotificationBase.extend({
        /**
         * Default severity for Chat Notification
         */
        severityDefault: 4,
        /**
         * Default category for Chat Notification
         */
        categoryDefault: 3,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls        : 'ui-icon-star',
        /**
         * this method must be implemented by all Notifications
         */
        getContent     : function () {
            return '<span>' +
                jimdoData.messages.chat.greeting +
                '</span><br /><a>' +
                jimdoData.messages.chat.link +
                '</a>';
        },

        globalAction: function () {
            if (!features('chatNotification')) {
                return;
            }

            var chatConfiguration = features.getPayload('chatNotification');

            diy.editor.chat.triggerChat(chatConfiguration);
        },

        getName: function() {
            return 'ChatNotification';
        }
    });
    module.exports = ChatNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/ChatNotification.js
 ** module id = 649
 ** module chunks = 0
 **/